import axios from 'axios';

// NOTE: This is temporary. Create a similar client that is used in register and types flow through automatically.
import type { DutchieCommonDomainModelsApiApiResult_1LeafLogixWebApiModelsEnvironmentDetailsDutchieCommonDomainVersion_1_0_0_0CultureNeutralPublicKeyTokenNull } from '@dutchie-pos/types/webapi';

export async function environmentDetailsQuery(): Promise<DutchieCommonDomainModelsApiApiResult_1LeafLogixWebApiModelsEnvironmentDetailsDutchieCommonDomainVersion_1_0_0_0CultureNeutralPublicKeyTokenNull> {
  const response = await axios.get(`/api/admin/environment-details`);
  return response.data;
}
